import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'userTypeName',
    standalone: false
})
export class UserTypeNamePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'WebAdmin':
        return 'Administrator';
      case 'Driver':
        return 'Sjåfør';
      case 'Store':
        return 'Opplaster';
      default:
        return value;
    }
  }
}
